import { css, SerializedStyles } from '@emotion/react'
import { isValid } from 'date-fns'
import type { VFC } from 'react'
import { Color, FontWeight, Size, Spacing, Typography } from '@opallabs/gem'
import { Conditional } from '@opallabs/kuiper'
import { DateRange } from '@opallabs/lapidary'

const dateStyles = css({
  ...Typography.M500,
  textTransform: 'uppercase',
  borderRadius: Size.Rounding * 2,
  cursor: 'default',
  flex: '0 0 auto',
  fontSize: 10,
  fontWeight: FontWeight.Semibold,
  paddingInline: Spacing.S,
  userSelect: 'none',
  whiteSpace: 'nowrap',
})

const dueDateStyles = (overdue: boolean): SerializedStyles =>
  css(
    {
      backgroundColor: overdue ? Color.dark.Surface.R100 : 'transparent',
      color: overdue ? Color.light.Text.Default : Color.light.Text.Gray,
    },
    dateStyles
  )

const noDueDateStyles = (overdue: boolean): SerializedStyles =>
  css(
    {
      backgroundColor: overdue
        ? Color.dark.Surface.R100
        : Color.light.Surface.N300,
      color: overdue ? Color.light.Text.Default : Color.light.Text.Gray,
    },
    dateStyles
  )

interface AssignmentDateProps {
  dueAtDate: boolean
  dueDate: Date
  overdue: boolean
}

export const AssignmentDate: VFC<AssignmentDateProps> = ({
  dueAtDate,
  dueDate,
  overdue,
}) => {
  // Don't show any date if there is no due date and no scheduled date
  if (!dueAtDate && !isValid(dueDate)) {
    return null
  }

  return (
    <div css={dueAtDate ? dueDateStyles(overdue) : noDueDateStyles(overdue)}>
      {overdue ? 'OVERDUE: ' : ''}
      <Conditional condition={isValid(dueDate)}>
        <DateRange startDate={dueDate} />
      </Conditional>
    </div>
  )
}
